import { getAuthInfo, mapTree, reRender } from '@/utils.js'
import { computed, onBeforeUnmount, toRaw } from 'vue'
import controllers from '@/components/controllers.js'
import componentMap from '@/components/componentMap.js'
import {
  abstractDataFromMetaComponentList,
  bubblingNode,
  createStylePortionByComponentType,
  firstLetterUpperCase,
  getNodeById,
  getNodesBySpecailProperty,
  getParentNode,
  getReverseValueInJson,
  isBelongToCSS,
  isHoverWord,
  isThreeEnds,
  loopArr,
  walkAllMetaComponentList,
  walkControllerAllGroup
} from './worker.js'
import ImportedWorker from './worker?worker&inline'
import { asyncNodeDataIntoTranslateRes, asyncTranslateResIntoNodeData } from '@/consts/lanuages.js'
import { reBuildControllerByActions } from '@/components/widgets/controllerUtils.js'
import { noBusinessNodes } from '@/components/common/controlBar/controlBarDialog/const.js'

import { filedMirgrants } from '@/fieldMirgrants/index.js'

import {
  getOtherUnitValueFromPixel,
  getPixelValueFromOtherUnit
} from '@/components/common/controlBar/controlBarDialog/metaComponent/unitTransform.js'

import { pickGradientKeys, transformToCssVarity } from '@/globalPopagation.js'

import {walkNodeUp} from "@/composables/newUtils.js";
import {isNotNumber} from "@/components/common/controlBar/controlBarDialog/metaComponent/height/utils.js";
import {setValueOfMuiltLanguagesJson} from "@/components/widgets/nav/repeatNumber.js";

// 加载js
function loadScript(scriptUrl) {
  return new Promise((resolve) => {
    var script = document.querySelector('script[src="' + scriptUrl + '"]')
    if (!script) {
      script = document.createElement('script')
      script.src = scriptUrl
      document.body.appendChild(script)
      script.onload = () => {
        resolve()
      }
    } else {
      resolve()
    }
  })
}

export function repairSyntaxFunction(fn) {
  return new Promise((resolve) => {
    Promise.all([
      loadScript('https://unpkg.com/prettier@3.2.4/standalone.js'),
      loadScript('https://unpkg.com/prettier@3.2.4/plugins/babel.js'),
      loadScript('https://unpkg.com/prettier@3.2.4/plugins/estree.js')
    ]).then((texts) => {
      var code = fn.toString()
      const formattedCode = prettier.format(code, {
        parser: 'babel',
        plugins: prettierPlugins
      })
      formattedCode.then((formattedCodeRes) => {
        resolve(formattedCodeRes)
      })
    })
  })
}

function supplimentPaddingAndBorder(res, node, deviceMode, metaComponent) {
  return (
    res +
    (() => {
      return getPixelValueFromOtherUnit(
        node.data.design['self_paddingUnit'][deviceMode],
        node.data.design['self_paddingBottom'][deviceMode],
        node,
        metaComponent
      )
    })() +
    (() => {
      return getPixelValueFromOtherUnit(
        node.data.design['self_paddingUnit'][deviceMode],
        node.data.design['self_paddingTop'][deviceMode],
        node,
        metaComponent
      )
    })() +
    (() => {
      if (node.data.design['self_borderBottomWidth']) {
        return node.data.design['self_borderBottomWidth'][deviceMode]
      } else {
        return 0
      }
    })() +
    (() => {
      if (node.data.design['self_borderTopWidth']) {
        return node.data.design['self_borderBottomWidth'][deviceMode]
      } else {
        return 0
      }
    })()
  )
}

// 得到原子控件项controller数据
export function getControllerData(node, key) {
  if (key === 'edit') {
    var res = computed(() => {
      if (node.controllerModule) {
        return node.controllerModule[key]
      } else {
        return '无'
      }
    })
    return res
  } else {
    var res = computed(() => {
      if (
        node.controllerModule &&
        node.controllerModule[key] &&
        node.controllerModule[key].metaComponentList
      ) {
        var json = {
          ...abstractDataFromMetaComponentList(node.controllerModule[key].metaComponentList)
          // v2: abstractDataFromMetaComponentList2(node.controllerModule[key].metaComponentList)
        }

        return json
      } else {
        return {}
      }
    })
    return res
  }
}

self.getControllerData = getControllerData

//
// export function getControllerData(node, key, isComputed){
//   var data
//   if(key === 'edit'){
//     if(
//       node.controllerModule){
//       data =  node.controllerModule[key]
//     }else{
//       data = '无'
//     }
//
//   }else{
//     if(
//       node.controllerModule &&
//       node.controllerModule[key] &&
//       node.controllerModule[key].metaComponentList){
//       data = abstractDataFromMetaComponentList(
//         node.controllerModule[key].metaComponentList
//       )
//     }else{
//       data = {}
//     }
//   }
//
//   var res
//   if(isComputed){
//     res = computed(()=>{
//       return data
//     })
//   }else{
//     res = data
//   }
//
//   return res
//
// }
// 从后台得到用户保存的配置文件值填充到原子控件某一项controller中（从样式数据）
const fillMetaComponentItemFromStyleData = (item, data) => {
  if (Object.prototype.toString.call(item.name) === '[object Object]') {
    //item.value = {}
    for (var cssKey in item.name) {
      var customKey = item.name[cssKey]
      if (data.hasOwnProperty(customKey)) {
        item.value[cssKey] = data[customKey]
      }
    }
  } else {
    if (data.hasOwnProperty(item.name)) {
      item.value = data[item.name]
    }
  }
}
// 从后台得到用户保存的配置文件值填充到所有原子控件项controller中（从样式数据）
export const fillMetaComponentListFromData = (data, metaComponentList, excludeFields = []) => {
  if (!Array.isArray(metaComponentList)) {
    return metaComponentList
  }
  metaComponentList.forEach((item) => {
    if (item.children) {
      item.children.forEach((subItem) => {
        if (!excludeFields.includes(subItem.englishTitle)) {
          fillMetaComponentItemFromStyleData(subItem, data)
        }
      })
    } else {
      fillMetaComponentItemFromStyleData(item, data)
    }
  })
  return metaComponentList
}
// 深拷贝
export const deepCloneObject = (obj) => {
  let clonedObj = {}
  for (let key in obj) {
    if (Array.isArray(obj[key])) {
      clonedObj[key] = deepCloneObject(obj[key]) // 对数组进行深克隆
    } else if (typeof obj[key] === 'object' && obj[key] !== null) {
      clonedObj[key] = deepCloneObject(obj[key]) // 对对象进行深克隆
    } else {
      clonedObj[key] = obj[key] // 基本数据类型直接复制
    }
  }
  return clonedObj
}

// 清洗旧数据（比如数据保存过但后期修改了数据结构）
export function washController(controller) {
  walkControllerAllGroup(controller, (group, key) => {
    group.children = group.children.filter((metaComponent) => {
      return typeof metaComponent !== 'undefined'
    })
  })
  return controller
}

self.walkAllMetaComponentList = walkAllMetaComponentList

// 复制控件（控制栏的复制功能）
export function copyNode(node) {
  const list = mm.store.state.hasList
  mm.utils.assignToList(list, node.id, (obj, parent, index) => {
    const newItem = mm.utils.deepCopy(node)
    const delAttr = (obj) => {
      delete obj.component
      if (obj.list) {
        obj.list.forEach((item2) => {
          delAttr(item2)
        })
      }
    }
    delAttr(newItem)

    parent.splice(index, 0, newItem)
    mm.store.commit('EMPTY_DIALOG')
    mm.store.commit('UPDATE_HAS_LIST', list)
    mm.store.commit('UPDATE_RECT')
  })
}

self.copyNode = copyNode

// 判断是否在最外行
export function isOutMostRow(rowNode) {
  var res = false
  var parentNode = getParentNode(rowNode)
  var grandParentNode
  if (parentNode) {
    grandParentNode = getParentNode(parentNode)
  }

  if (
    parentNode &&
    parentNode.componentName === 'module' &&
    grandParentNode &&
    (grandParentNode.componentName === 'base' ||
      grandParentNode.componentName === 'head' ||
      grandParentNode.componentName === 'content' ||
      grandParentNode.componentName === 'foot')
  ) {
    res = true
  }
  return res
}

// 通过id删除节点（邮件删除）
export function deleteNodeById(id, rootList) {
  mm.utils.assignToList(rootList, id, (obj, parent, index) => {
    parent.splice(index, 1)
  })
  mm.store.commit('EMPTY_DIALOG')
}

//  得到后端结构
export function getBackEndStructorOfNodeById(id) {
  var arr = ['componentName', 'id', 'name', 'data', 'list']
  var json = {}
  var node = getNodeById(id)
  arr.forEach((key) => {
    json[key] = node[key]
  })

  return json
}

globalThis.getBackEndStructorOfNodeById = getBackEndStructorOfNodeById

//  通过flag得到节点
export function getNodeByFlag(node, flag, property = 'flag') {
  var match = getNodesBySpecailProperty(property, flag, [node])[0]
  if (match) {
    return match
  } else {
    console.warn('没有此flag: ' + flag)
    return false
  }
}

self.getNodeByFlag = getNodeByFlag

//  得到外层节点
export function getOuterNodesOfAssembleNode(assembleNode) {
  var arr = []
  walkNode(assembleNode, (walkedNode) => {
    arr.push(walkedNode)
  })

  return arr
}

//  得到节点架构
export function getNodeConstructorById(id) {
  var node = getNodeById(id)
  var clonedNode = deepCopy(node)
  walkNode(clonedNode, (walkedNode) => {
    delete walkedNode.controllerModule
    delete walkedNode.modeData
    delete walkedNode.actions
    delete walkedNode.translateRes
    delete walkedNode.id
    delete walkedNode._index
  })
  return clonedNode
}

self.getNodeConstructorById = getNodeConstructorById

// 渲染节点策略
export function renderNodeStrategy(node, modeJson, isFirstLoad, renderFn) {
  function renderTemplate() {
    reRender(node, modeJson.list)
  }

  if (mm.router.currentRoute.value.query.editTemplate) {
    if (isFirstLoad) {
      renderTemplate()
    }
  } else {
    renderFn()
  }
}

// 判断节点是否在另一个节点内部
export function isInNode(node, ancestorNode) {
  var res = false
  let isContinue = true
  while (isContinue) {
    var parentNode = getParentNode(node)
    if (parentNode) {
      if (parentNode.id === ancestorNode.id) {
        isContinue = false
        res = true
      } else {
        node = parentNode
      }
    } else {
      isContinue = false
    }
  }
  return res
}

//  通过组件名得到最接近的节点（暂没有使用）
export function getCloestNodeByComponentName(node, componentName) {
  var res = null
  let isContinue = true
  while (isContinue) {
    var parentNode = getParentNode(node)
    if (parentNode) {
      if (parentNode.componentName === componentName) {
        isContinue = false
        res = parentNode
      } else {
        node = parentNode
      }
    } else {
      isContinue = false
    }
  }
  return res
}

//  通过组件名得到节点（暂无使用）
export function getNodesByComponentName(node, componentName) {
  var res = []
  walkNode(node, (walkedNode) => {
    if (walkedNode.componentName === componentName) {
      res.push(walkedNode)
    }
  })
  return res
}

//  得到祖先节点（右键菜单）
export function getAncestorNodes(node) {
  var res = []
  bubblingNode(node, (bubblingNode) => {
    res.push(bubblingNode)
  })
  return res
}

//  节点包裹（改的json文件）
export function wrapedNodeByDivNode(node, wrappedNode) {
  var parentNode = getParentNode(node)
  var index = parentNode.list.indexOf(node)
  parentNode.list.splice(
    index,
    1,
    extraNode({
      ...wrappedNode,
      list: [node]
    })
  )
  mm.store.commit('UPDATE_HAS_LIST', mm.store.state.hasList)
  mm.store.commit('UPDATE_RECT')
}

self.wrapedNodeByDivNode = wrapedNodeByDivNode

// 节点包裹（改的json文件）（暂无使用）
export function wrapedNodeByNewParentNode(node) {
  var parentNode = getParentNode(node)

  parentNode.list = [
    extraNode({
      name: '内容容器',
      componentName: 'divContainer',
      list: [node]
    })
  ]

  mm.store.commit('UPDATE_HAS_LIST', mm.store.state.hasList)
  mm.store.commit('UPDATE_RECT')
}

self.wrapedNodeByNewParentNode = wrapedNodeByNewParentNode

//  删除节点
export function deleteNode(node) {
  mm.utils.assignToList(mm.store.state.hasList, node.id, (obj, parent, index) => {
    parent.splice(index, 1)
  })
  mm.store.commit('UPDATE_HAS_LIST', mm.store.state.hasList)
  mm.store.commit('UPDATE_RECT')
  mm.store.commit('EMPTY_DIALOG')
}

//  节点插入
export function appendNodeIntoTargetNode(node, recieveNode) {
  recieveNode.list.push(extraNode(node))

  mm.store.commit('UPDATE_HAS_LIST', mm.store.state.hasList)
  mm.store.commit('UPDATE_RECT')
}

self.appendNodeIntoTargetNode = appendNodeIntoTargetNode

//  节点插入（已存在节点）
export function appendExistedNodeIntoTargetNode(node, recieveNode) {
  deleteNode(node)
  appendNodeIntoTargetNode(node, recieveNode)
}

//  节点插入后，添加一个空节点
export function afterInsetNewNode(node) {
  var parentNode = getParentNode(node)
  var index = parentNode.list.indexOf(node)
  parentNode.list.splice(
    index + 1,
    0,
    extraNode({
      name: '内容容器',
      componentName: 'divContainer',
      list: []
    })
  )
  mm.store.commit('UPDATE_HAS_LIST', mm.store.state.hasList)
  mm.store.commit('UPDATE_RECT')
}

self.afterInsetNewNode = afterInsetNewNode

// 节点追加子节点
export function appendChildNode(node, childNodeConfig) {
  node.list.push(extraNode(childNodeConfig))
  mm.store.commit('UPDATE_HAS_LIST', mm.store.state.hasList)
  mm.store.commit('UPDATE_RECT')
}

self.appendChildNode = appendChildNode

self.getParentNode = getParentNode
self.getNodeById = getNodeById
self.getNodesBySpecailProperty = getNodesBySpecailProperty

function parseTranslateDataIntoPage() {}

self.parseTranslateDataIntoPage = parseTranslateDataIntoPage

// 驼峰转横线
export function linethroughToHump(str) {
  var [first, ...rest] = str.split('-')
  return (
    first +
    (() => {
      var res = rest
        .map((item) => {
          return firstLetterUpperCase(item)
        })
        .join('')
      return res
    })()
  )
}

// 横线转驼峰
export function humpToLinethrough(str) {
  var arr = str.split('')
  arr = arr.map((item, index) => {
    if (isUpperCase(item)) {
      return '-' + item.toLowerCase()
    } else {
      return item
    }
  })

  return arr.join('')
}

// 判断是否为大写
export function isUpperCase(letter) {
  return /^[A-Z]$/.test(letter)
}

//  判断节点是否为组件
export function isBelongAssembleNode(node) {
  var arr = [
    'product_tabNew_style1',
    'product_imgTextNew_style1',
    'list_product_style1',
    'list_product_style2',
    'list_product_style3',
    'list_product_style4',
    'list_product_style5',
    'list_product_style6',
    'list_product_style7',
    'list_product_style8',
    'list_product_style9',
    'list_product_style12',
    'list_product_style13',
    'list_product_style14',
    'list_download_style1',
    'list_download_style2',
    'list_download_style3',
    'list_download_style4',
    'list_case_style1',
    'list_case_style2',
    'list_case_style3',
    'list_case_style4',
    'list_case_style5',
    'list_case_style6',
    'list_case_style7',
    'list_news_index_style1',
    'list_news_index_style3',
    'list_news_index_style4',
    'list_news_index_style5',
    'list_news_index_style6',
    'list_news_index_style7'
  ]

  return arr.includes(node._type)
}

//  获取默认值（暂无使用）
function getDefaultValueOfCssKey(cssKey) {
  var defaultValueOfCssKeyMap = {
    'background-color': 'transparent'
  }
  return defaultValueOfCssKeyMap[cssKey]
}

// 添加默认值（暂无使用）
function addDefalutValueIfUndefined(componentType, value) {
  if (componentType === 'border') {
    value['border-top-style'] = value['border-top-style'] || {
      diannao: 'solid',
      pingban: 'solid',
      shouji: 'solid'
    }
    value['border-right-style'] = value['border-right-style'] || {
      diannao: 'solid',
      pingban: 'solid',
      shouji: 'solid'
    }
    value['border-bottom-style'] = value['border-bottom-style'] || {
      diannao: 'solid',
      pingban: 'solid',
      shouji: 'solid'
    }
    value['border-left-style'] = value['border-left-style'] || {
      diannao: 'solid',
      pingban: 'solid',
      shouji: 'solid'
    }
  }

  // if(value){
  //   Object.keys(value).forEach((cssKey)=>{
  //     ['diannao', 'pingban' ,'shouji' ].forEach((deviceMode)=>{
  //       if(value[cssKey][deviceMode] === ''){
  //         value[cssKey][deviceMode] = getDefaultValueOfCssKey(cssKey)
  //       }
  //     })
  //   })
  // }

  return value
}

export function isThreeEndConstructor(value) {
  var res = true
  if (
    !(
      value.hasOwnProperty('diannao') &&
      value.hasOwnProperty('pingban') &&
      value.hasOwnProperty('shouji')
    )
  ) {
    res = false
  }
  return res
}

//  创建配置项
export function createConfig({
  title,
  componentType,
  element,
  name,
  isInHover = false,
  value,
  options = [],
  isHide,
  layout,
  customConfig,
  min,
  max,
  disabled,
  unitFilters,
  hFilters,
  isShowSlider,
  maxLineHeight,
  fontSizeUnitIsView,
  hidenBackgroundImg,
  imageEffectHide,
  borderPosidion = 'bottom',
  hiddenDirectionBox = false,
  rules,
  needTranslate,
  dataSourceType,
  englishTitle,
  needReRender,
  hideRadioDot = false,
  hiddenPixel = false,
  onChange = () => {},
  labelWidth = 73,
  unitList = [],
  showMarginItems = undefined,
  marginType,
  isCreateHoverClassName,
  cacheKey = Date.now(),
  showLanguagePackage,
  hidenGradient,
  showImageSize,
  widgetName,
  isShowSyncOtherLanguages = false,
  isEnhanceHeight = false,
  isEnhanceTextOverFlow = false,
  mapFlag = '',
  step,
  precision,
  getByFlag
}) {
  if (!englishTitle) {
    console.error(title + ', 请补充 englishTitle')
  }

  // 初始值格式检查
  if (isBelongToCSS(componentType)) {
    for (var key in value) {
      if (!isThreeEndConstructor(value[key])) {
        console.error(`${title}:  数据格式无效，请写 三端格式数据`)
      }
    }
  }

  // 补充默认值，如果没有设置的话
  value = addDefalutValueIfUndefined(componentType, value)

  name = (() => {
    // 有名字，使用自己的名字
    if (typeof name !== 'undefined') {
      return name
    }
    // 没有名字，生成名字
    var json = {}
    for (var key in value) {
      json[key] = createCustomName(element, key, componentType, isInHover)
    }
    return json
  })()

  return {
    id: 'metComponent' + Date.now() + Math.random(),
    title,
    componentType,
    value,
    name,
    options,
    isHide,
    layout,
    min,
    max,
    unitFilters,
    hFilters,
    customConfig,
    isShowSlider,
    maxLineHeight,
    fontSizeUnitIsView,
    hidenBackgroundImg,
    imageEffectHide,
    borderPosidion,
    hiddenDirectionBox,
    rules,
    needTranslate,
    dataSourceType,
    englishTitle,
    needReRender,
    hiddenPixel,
    onChange,
    labelWidth,
    unitList,
    showMarginItems,
    marginType,
    element,
    hideRadioDot,
    isSyncHover: false,
    isInHover,
    isCreateHoverClassName,
    cacheKey,
    showLanguagePackage,
    disabled,
    mapFlag,
    isNeedSynchronousThreeEndRule: (() => {
      var arr = ['columsLengthOfListV2', 'listItemLength']
      if (arr.includes(componentType)) {
        return false
      } else {
        return true
      }
    })(),
    hidenGradient,
    showImageSize,
    widgetName,
    isShowSyncOtherLanguages,
    isEnhanceHeight,
    isEnhanceTextOverFlow,
    step,
    precision,
    getByFlag
  }
}

//  创建自定义名字（防止类名冲突，保证字段唯一性）
export function createCustomName(element, key, componentType, isInHover) {
  return `${(() => {
    if (element) {
      return `${element}_`
    } else {
      return ''
    }
  })()}${(() => {
    if (isBelongToCSS(componentType)) {
      return isHoverWord(linethroughToHump(key), isInHover)
    } else {
      return linethroughToHump(key)
    }
  })()}`
}

//  判断是否为原子组件的key
export function isMetaComponentListKey(key, controllerModule) {
  var res = false
  if (controllerModule[key] && controllerModule[key].metaComponentList) {
    res = true
  }

  return res
}

//  获取所有controller数据
export function getAllControllerData(node) {
  var json = {}
  for (var key in node.controllerModule) {
    if (isMetaComponentListKey(key, node.controllerModule)) {
      var a = getControllerData(node, key)
      json[key] = a.value
    } else {
      json[key] = node.controllerModule[key]
    }
  }
  return json
}

globalThis.getAllControllerData = getAllControllerData

// 将数据填充进controller
export function pourDataIntoController(controllerModule, data) {
  if (data) {
    for (var key in data) {
      if (controllerModule.hasOwnProperty(key)) {
        if (isMetaComponentListKey(key, controllerModule)) {
          if (data[key]) {
            fillMetaComponentListFromData(data[key], controllerModule[key].metaComponentList)
          }
        } else {
          if (key === 'isShow') {
            if (typeof data[key] !== 'undefined') {
              controllerModule[key] = data[key]
            }
          } else {
            controllerModule[key] = data[key]
          }
        }
      }
      if (key === 'contactTop') {
        controllerModule[key] = data[key]
      }
    }
  }
  return controllerModule
}

//  将数据填充进controller，只修改'edit', 'attribute'以外的数据
export function pourDataIntoControllerRemoveField(controllerModule, data, excludeFields = [], removedKeys = ['edit', 'attribute']) {
  if (data) {
    for (const key in data) {
      if (!removedKeys.includes(key)) {
        if (key in controllerModule) {
          if (isMetaComponentListKey(key, controllerModule)) {
            if (data[key]) {
              fillMetaComponentListFromData(data[key], controllerModule[key].metaComponentList, excludeFields)
            }
          } else {
            if (key === 'isShow') {
              if (typeof data[key] !== 'undefined') {
                controllerModule[key] = data[key]
              }
            } else {
              controllerModule[key] = data[key]
            }
          }
        }
      }
    }
  }
  return controllerModule
}

//  遍历所有元子组件
export function walkAllMetaComponents(controllerModule, callback) {
  walkControllerAllGroup(controllerModule, (group, key) => {
    group.children.forEach((metaComponent) => {
      callback(metaComponent, key)
    })
  })
}

// 根据自定义key（controller中的element和value拼装的）获取元子组件
export function getMetaComponentByCustomKey(customKey, controllerModule) {
  var res
  walkAllMetaComponents(controllerModule, (walkedMetaComponent) => {
    if (Object.values(walkedMetaComponent.name).includes(customKey)) {
      res = walkedMetaComponent
    }
  })
  return res
}

// 判断是否为三端json格式
function isOkThreeEndJson(threeEndJson) {
  var res = true
  for (var threeEndKey in threeEndJson) {
    if (threeEndKey === 'diannao' || threeEndKey === 'pingban' || threeEndKey === 'shouji') {
      if (
        !(
          Object.prototype.toString.call(threeEndJson[threeEndKey]) === '[object String]' ||
          Object.prototype.toString.call(threeEndJson[threeEndKey]) === '[object Number]' ||
          Object.prototype.toString.call(threeEndJson[threeEndKey]) === '[object Null]'
        )
      ) {
        res = false
      }
    }
  }
  return res
}

// 过滤掉错误的数据（删掉脏数据）
function filterBadData(node, controllerModule) {
  for (var key in node.data) {
    if (isMetaComponentListKey(key, controllerModule)) {
      for (var customKey in node.data[key]) {
        var matchMetaComponent = getMetaComponentByCustomKey(customKey, controllerModule)
        if (matchMetaComponent) {
          if (isBelongToCSS(matchMetaComponent.componentType)) {
            var threeEndJson = node.data[key][customKey]
            if (Object.prototype.toString.call(threeEndJson) !== '[object Object]') {
              delete node.data[key][customKey]
            } else {
              if (!threeEndJson.hasOwnProperty('diannao')) {
                delete node.data[key][customKey]
              } else {
                if (!isOkThreeEndJson(threeEndJson)) {
                  delete node.data[key][customKey]
                }
              }
            }
          }
        }
      }
    }
  }

  return node
}

//  解析url
export function parseUrl(url) {
  var a = document.createElement('a')
  a.href = url
  return {
    host: a.hostname,
    query: a.search,
    params: (function () {
      var ret = {},
        seg = a.search.replace(/^\?/, '').split('&'),
        len = seg.length,
        i = 0,
        s
      for (; i < len; i++) {
        if (!seg[i]) {
          continue
        }
        s = seg[i].split('=')
        //ret[s[0]] = s[1];
        ret[s[0]] = decodeURIComponent(s[1])
      }
      return ret
    })(),
    hash: a.hash.replace('#', '')
  }
}

self.parseUrl = parseUrl

// 创建url
function createUrl(newParms) {
  var json = parseUrl(location.href).params
  for (var key in newParms) {
    json[key] = newParms[key]
  }

  json.temp = Date.now()

  var arr = []
  for (var key in json) {
    arr.push(key + '=' + json[key])
  }

  return location.origin + location.pathname + '?' + arr.join('&')
}

self.createUrl = createUrl

//  获取action名称
export function getActionName(action) {
  if (typeof action === 'string') {
    return action
  } else if (typeof action === 'object') {
    return action?.name || ''
  }
}

// 创建controller
export function createControlller2(node) {
  var fn = controllers[node.componentName]

  var controllerModule = fn(node)

  controllerModule = reBuildControllerByActions(controllerModule, node)
  node = filterBadData(node, controllerModule)

  controllerModule = pourDataIntoController(controllerModule, node.data)
  return controllerModule
}

export function toUpperCase(string, isUpperCase) {
  if (isUpperCase) {
    return string.replace(/\w/g, (letter) => {
      return letter.toUpperCase()
    })
  } else {
    return string
  }
}

export function isAllUpperCase(string) {
  var div = document.createElement('div')
  div.innerHTML = string
  string = div.innerText

  var letters = string.split('').filter((stringItem) => {
    return stringItem.match(/\w/)
  })

  var word = letters.join('')

  var res = word === word.toUpperCase()

  return res
}

export function syncValuesOfText(node, newVal) {
  node.controllerModule.edit = newVal
  asyncNodeDataIntoTranslateRes(node)
}

//根据组件名称创建配置项
function setConfigByComponentName(node) {
  var baseWidgetActionMap = {
    text_title: [
      'edit',
      {
        name: 'design',
        config: {
          分组1: [
            'self_upperLowerCase',
            'self_background',
            'title_textTheme',
            'title_fontFamily',
            'title_fontSize',
            'self_textHollowOut',
            'title_color',
            'stroke_color',
            'hollow_color',
            'title_textStyle',
            'title_textAlign',
            'title_lineHeight',
            'title_letterSpace',
            'self_margin',
            'self_padding',
            'title_h',
            'title_textOverflow',
            'self_zIndex',
            'self_textShadow'
          ]
        }
      },
      'hover',
      'animate',
      'link',
      'translate',
      'style',
      'store',
      'isShow'
    ],
    text_paragraph: [
      'edit',
      {
        name: 'design',
        config: {
          分组1: [
            'self_upperLowerCase',
            'self_background',
            'title_textTheme',
            'title_fontFamily',
            'title_fontSize',
            'self_textHollowOut',
            'title_color',
            'stroke_color',
            'hollow_color',
            'title_textStyle',
            'title_textAlign',
            'title_lineHeight',
            'title_letterSpace',
            'self_margin',
            'self_padding',
            'title_h',
            'title_textOverflow',
            'self_zIndex',
            'self_textShadow'
          ]
        }
      },
      'hover',
      'animate',
      'link',
      'translate',
      'style',
      'store',
      'isShow'
    ],
    text_scrollText: [
      'attribute',
      {
        name: 'design',
        config: {
          分组1: [
            'self_background',
            'title_textTheme',
            'title_fontFamily',
            'title_fontSize',
            'self_textHollowOut',
            'scrollTextunit_fontSize',
            'title_gapOfListV2',
            'title_color',
            'stroke_color',
            'hollow_color',
            'title_textStyle',
            'title_textAlign',
            'title_lineHeight',
            'title_letterSpace',
            'self_margin',
            'self_padding',
            'self_zIndex'
          ]
        }
      },
      'style',
      'store',
      'translate',
      'isShow'
    ],
    button_text: [
      {
        name: 'design',
        groupLayout: 'topBottom',
        config: {
          文字设计: [
            'self_textInput',
            'self_upperLowerCase',
            'self_textTheme',
            'self_fontFamily',
            'self_fontSize',
            'self_color',
            'self_textStyle',
            'self_textAlign'
            //'self_borderRadius',
          ],
          按钮设计: [
            'self_background',
            'self_zIndex',
            'self_border',
            'self_margin',
            'self_padding',
            'self_transverseMargin2',
            'self_borderRadius',
            'self_shadow',
            'self_width'
          ]
        }
      },
      'hover',
      'animate',
      'translate',
      'link',
      'style',
      'store',
      'isShow'
    ],
    button_text_icon: [
      'design',
      'hover',
      'animate',
      'translate',
      'link',
      'style',
      'store',
      'isShow'
    ]
  }

  node.actions = node.actions || baseWidgetActionMap[node.componentName]

  return node
}

// 遍历后端的模块列表
export function walkBackEndModuleList(callback) {
  var data = window.moduleListData
  data.list.forEach((item) => {
    if (item.module_list) {
      item.module_list.forEach((subItem) => {
        callback(subItem, item)
      })
    }
  })
}

// 遍历后端的控件列表
export function walkBackEndControlList(callback) {
  window.controlListData.list.forEach((item) => {
    if (item.children) {
      item.children.map((item) => {
        if (item.children) {
        } else {
          item.list.forEach((item2) => {
            callback(item2, item)
          })
        }
      })
    } else {
      item.list.forEach((item2) => {
        callback(item2, item)
      })
    }
  })
}

//  获取节点的显示名称
export function getShowNameOfNode(node) {
  var res
  walkBackEndControlList((item, parentItem) => {
    if ((item.option || item.name) === node._type) {
      res = parentItem.name
    }
  })

  if (node.useSelfName) {
    return node.name
  }
  if (res == '一行多列') {
    res = node.name
  }
  return res || node.name
}

//  扩展节点（增加controller）
export function extraNode(node, isEdit = false) {
  walkNode(node, (walkedNode) => {
    walkedNode = filedMirgrants(walkedNode)

    if (typeof walkedNode._type === undefined) {
      console.error(walkedNode.name + '请补充 _type属性')
      return
    }

    if(walkedNode.componentName === 'slider'){
      walkedNode.swiperId = 'slider_' + parseInt((Date.now() + (Math.random() * 10000000000000)))
    }


    walkedNode = setConfigByComponentName(walkedNode)

    // if (isEdit) {
    asyncTranslateResIntoNodeData(walkedNode)
    // }

    walkedNode.controllerModule = createControlller2(walkedNode)
    walkedNode.cacheKey = walkedNode.cacheKey || Date.now()

    if (!isEdit) {
      asyncNodeDataIntoTranslateRes(walkedNode)
    }

    walkControllerAllGroup(walkedNode.controllerModule, (group, key) => {
      if (key === 'hover') {
        group.children = group.children.filter((metaComponent) => {
          if (
            metaComponent.componentType === 'fontSize' ||
            metaComponent.componentType === 'width' ||
            metaComponent.componentType === 'height' ||
            metaComponent.componentType === 'margin' ||
            metaComponent.componentType === 'padding'
          ) {
            return false
          } else {
            return true
          }
        })
      }
    })
  })
  return node
}

self.extraNode = extraNode

// sessionStorage请求·（防止重复请求）
export function sessseionRequest(key, callback) {
  return new Promise((resolve) => {
    var sessionRes = sessionStorage.getItem(key)
    if (sessionRes) {
      resolve(JSON.parse(sessionRes))
    } else {
      var promise = callback()
      promise.then((data) => {
        sessionStorage.setItem(key, JSON.stringify(data))
        resolve(data)
      })
    }
  })
}

var requestMap = {}
self.requestMap = requestMap

export async function requestData(opts) {
  return new Promise((resolve) => {
    if (opts.enableCache) {
      resolve(requestMap[opts.url + JSON.stringify(opts.params)])
    } else {
      requestMap[opts.url + JSON.stringify(opts.params)] = undefined
      delete requestMap[opts.url + JSON.stringify(opts.params)]
      mm.http(opts).then((res) => {
        requestMap[opts.url + JSON.stringify(opts.params)] = res

        resolve(requestMap[opts.url + JSON.stringify(opts.params)])
      })
    }
  })
}

function deepTraverse(travelObj, callback, parent, matchKey) {
  if (Array.isArray(travelObj)) {
    travelObj.forEach((subItem) => {
      deepTraverse(subItem, callback, travelObj)
    })
  } else if (travelObj && typeof travelObj === 'object') {
    Object.keys(travelObj).forEach((key) => {
      deepTraverse(travelObj[key], callback, travelObj, key)
    })
  } else {
    callback(parent, matchKey)
  }
}

let worker
var resovleMap = {}

//  创建样式模版
export function createStyleModle(node, deviceMode) {
  var style = {}
  walkAllMetaComponentList(node, (walkedMetaComponent, parent) => {
    if (isBelongToCSS(walkedMetaComponent.componentType)) {
      createStylePortionByComponentType(node, walkedMetaComponent, style, deviceMode)
    }
  })

  if (node.componentName === 'popagation') {
    if (style['.% .popagationtext:hover']) {
      style['.% .popagationtext.active'] = style['.% .popagationtext:hover']
    }
  }
  return style
}

// 获取最接近的业务节点
export function getClosestBusinessNode(node) {
  var res
  if (mm.router.currentRoute.value.query.editTemplate) {
    res = node
  } else {
    // 非编辑模式下 跳到第一个业务节点
    walkNodeUp(node, (bubblingNode) => {
      if (
        mm.utils.checkCol(bubblingNode) ||
        (!noBusinessNodes.includes(bubblingNode.componentName) && !bubblingNode?.disabled) ||
        (noBusinessNodes.includes(bubblingNode.componentName) && bubblingNode?.forceShow) ||
        (noBusinessNodes.includes(bubblingNode.componentName) && bubblingNode?.forceShowInMenuList)
      ) {
        if (!res) {
          res = bubblingNode
        }
      }
    })
  }
  return res
}

// 创建worker（解析样式）
function workerPromise(deviceMode, isRender, nodeList) {
  return new Promise((resolve) => {
    var resolveId = Date.now()
    resovleMap[resolveId] = resolve

    if (!worker) {
      worker = new ImportedWorker()
      worker.onmessage = function (event) {
        var json = JSON.parse(event.data)

        if (typeof resovleMap[json.resolveId] === 'function') {
          resovleMap[json.resolveId](json.data)
        }

        resovleMap[json.resolveId] = undefined
        delete resovleMap[json.resolveId]
      }
    }
    worker.postMessage({
      renoToken: 'sdasfdfsddfsddfas===',
      resolveId,
      deviceMode,
      isRender,
      rootList: (() => {
        var arr = mm.utils.deepCopy(nodeList)
        var res = mapTree(arr, 'list', (node) => {
          return {
            controllerModule: (() => {
              var newControllerModule = deepCopy(node.controllerModule)
              walkControllerAllGroup(newControllerModule, (group, key) => {
                group.children.forEach((metaComponent) => {
                  deepTraverse(metaComponent, (parent, key) => {
                    // 函数类型，无法传递，需要去掉
                    if (typeof parent[key] === 'function') {
                      parent[key] = undefined
                      delete parent[key]
                    }
                  })
                })
              })

              return newControllerModule
            })(),
            data: getAllControllerData(node, true),
            list: node.list,
            id: node.id,
            // flag: node.flag,
            name: node.name,
            unsave_hoverWhole: node.unsave_hoverWhole,
            notHoverWhole:node.notHoverWhole,
            unsave_hoverWholeExclude: node.unsave_hoverWholeExclude,
            unsave_clickUseHoverWhole: node.unsave_clickUseHoverWhole,
            _type: node._type,
            componentName: node.componentName,
            styleModule: createStyleModle(node, deviceMode)
          }
        })
        return res
      })(),
      globalFont: (() => {
        var list = JSON.parse(localStorage.getItem('fontList'))
        var match = list.find((item) => {
          return item.id === mm.store.state.authInfo.a_ksh_font_id
        })
        if (match) {
          return match.name
        } else {
          return undefined
        }
      })(),
      rootStyle: pickGradientKeys(),
      mediaQueryConfig: toRaw(mm.store.state.authInfo.mediaQueryConfig),
      pcResponse: mm.store.state.authInfo.ksh_global_theme_color.pcResponse
    })
  })
}

// 判断是否为基础模块
export const isBaseModule = (node) => {
  var res = false
  if (node.componentName === 'module' && node.id.split('_').length === 3) {
    res = true
  }
  return res
}

//  同步hover值（设计中的是否同步划过）
export function asyncHoverValue(node, data) {
  if (data.componentType === 'fontSize') {
    Object.values(data.name).forEach((customName) => {
      var [element, valueName] = customName.split('_')
      var hoverCustomName = element + '_hover' + firstLetterUpperCase(valueName)
      modifyValueByCustomName(getNodeById(node.id), hoverCustomName, 111)
    })
  }
}

let parseNodesStyleCount = 0
//  批量解析样式（controller转样式）
export const parseNodesStyle = async (
  deviceMode = mm.store.state.deviceMode,
  isRender = true,
  nodeList = mm.store.state.hasList,
  isEnableHoverEffect = false
) => {
  parseNodesStyleCount++
  self.isEnableHoverEffect = isEnableHoverEffect || !!localStorage.getItem('hoverEffect')
  loopArr(nodeList, (node) => {
    if (node) {
      //此行不能删除， 否则数据不渲染  start
      if (!node.data) {
        node.data = {}
      }

      Object.defineProperty(node, 'data', {
        get: function () {
          return getAllControllerData(node)
        },
        set: function () {
          console.error('该属性为只读属性，不可修改')
        }
      })
      //此行不能删除， 否则数据不渲染  end
    }
  })

  var json = await workerPromise(deviceMode, isRender, nodeList)

  if (isRender) {
    loopArr(nodeList, (node) => {
      var styleDom = getStyleDomByNode(node, deviceMode)
      styleDom.innerText = json[node.id]
    })

    var styleDom = getStyleDomByNode(
      {
        id: 'commonStyle'
      },
      deviceMode
    )
    styleDom.innerText = json.commonStyle
  }

  let combinedResult = (() => {
    var res = ''
    for (var key in json) {
      res += json[key]
    }
    return res
  })()

  return combinedResult
}
self.parseNodesStyle = parseNodesStyle

//  三端样式解析
function parseMediaByMode(mode, content) {
  if (mode === 'diannao') {
    return `
      @media screen and (min-width: 992px)
      {
          ${content}
      }
    `
  } else if (mode === 'pingban') {
    return `
      @media screen and (min-width: 768px) and (max-width: 991px)
      {
          ${content}
      }
    `
  } else if (mode === 'shouji') {
    return `
      @media screen and (max-width:767px)
      {
          ${content}
      }
    `
  }
}

//  头部三端样式解析
export async function parseThreeEndStyleOfHeader(isRender) {
  return await parseThreeEndStyle(isRender, [mm.store.state.hasList[0]])
}

// body内容三端样式解析
export async function parseThreeEndStyleOfContent(isRender, type = 'page', infoVal) {
  return await parseThreeEndStyle(
    isRender,
    type === 'page' ? [mm.store.state.hasList[1]] : [infoVal.content]
  )
}

// 底部三端样式解析
export async function parseThreeEndStyleOfFooter(isRender) {
  return await parseThreeEndStyle(isRender, [mm.store.state.hasList[2]])
}

//  所有三端样式解析
export async function parseThreeEndStyleOfAll(isRender) {
  var res = ''
  res += await parseThreeEndStyleOfHeader(isRender)
  res += await parseThreeEndStyleOfContent(isRender)
  res += await parseThreeEndStyleOfFooter(isRender)
  return res
}

self.parseThreeEndStyleOfHeader = parseThreeEndStyleOfHeader
self.parseThreeEndStyleOfFooter = parseThreeEndStyleOfFooter
self.parseThreeEndStyleOfContent = parseThreeEndStyleOfContent

//  全部三端样式解析
export async function parseThreeEndStyle(isRender, nodeList) {
  let extraStyles = ''
  let styles =
    extraStyles +
    (await parseNodesStyle(
      'diannao',
      isRender,
      nodeList,
      (() => {
        if (isRender) {
          return false
        } else {
          return true
        }
      })()
    ))
  let pingbanStyles =
    extraStyles +
    (await parseNodesStyle(
      'pingban',
      isRender,
      nodeList,
      (() => {
        if (isRender) {
          return false
        } else {
          return true
        }
      })()
    ))
  let shoujiStyles =
    extraStyles +
    (await parseNodesStyle(
      'shouji',
      isRender,
      nodeList,
      (() => {
        if (isRender) {
          return false
        } else {
          return true
        }
      })()
    ))

  return `
            ${parseMediaByMode('shouji', shoujiStyles)}
            ${parseMediaByMode('pingban', pingbanStyles)}
            ${parseMediaByMode('diannao', styles)}
          `
}

self.modifyValueByCustomName = modifyValueByCustomName

/**
 * 根据自定义名称修改节点的值
 * @param {Object} node - 要修改的节点对象
 * @param {string} customName - 自定义属性名称
 * @param {*} value - 要设置的新值
 */
export function modifyValueByCustomName(
  node,
  customName,
  value,
  deviceMode = mm.store.state.deviceMode
) {
  var match = getMetaComponentItemByCustomName(node, customName)
  if (match) {
    var cssKey = getReverseValueInJson(match.name, customName)
    if (isThreeEnds(match.value[cssKey]) && typeof value !== 'object') {
      match.value[cssKey][deviceMode] = value
    } else {
      match.value[cssKey] = value
    }
  }
}

// 根据设备模式修改节点的值
export function modifyValueByDeviceMode(node, customName, value, deviceMode) {
  var match = getMetaComponentItemByCustomName(node, customName)
  if (match) {
    var cssKey = getReverseValueInJson(match.name, customName)
    if (isThreeEnds(match.value[cssKey]) && typeof value !== 'object') {
      match.value[cssKey][deviceMode] = value
    } else {
      match.value[cssKey] = value
    }
  }
}

//  根据自定义名称获取节点的值
export function getValueByCustomName(node, customName) {
  var match = getMetaComponentItemByCustomName(node, customName)
  if (match) {
    var cssKey = getReverseValueInJson(match.name, customName)
    if (isThreeEnds(match.value[cssKey]) && typeof value !== 'object') {
      return match.value[cssKey][mm.store.state.deviceMode]
    } else {
      return match.value[cssKey]
    }
  }
}

self.getValueByCustomName = getValueByCustomName

//  判断是否来自用户管理平台(权限)
export function isFromUserManagePlat() {
  if (!getAuthInfo().type) {
    return true
  } else {
    return false
  }
}

//  强制同步3端（字号）
function forcesynchronousThreeEnd(json, item, value) {
  if (!json.value[item]['pingban_isChange']) {
    json.value[item]['pingban'] = value
  }

  if (!json.value[item]['shouji_isChange']) {
    json.value[item]['shouji'] = value
  }
}

function excuteSynchronousAction(json, item, value, deviceMode) {
  if (deviceMode === 'diannao') {
    if (!json.value[item]['pingban_isChange']) {
      json.value[item]['pingban'] = value
    }

    if (!json.value[item]['shouji_isChange']) {
      json.value[item]['shouji'] = value
    }
  } else {
    if (!json.value[item]['shouji_isChange']) {
      json.value[item]['shouji'] = value
    }
  }
}

export function getAvialUnit(json, item, value){
  var unit = Object.keys(json.value).find((key) => {
    return key.match('unit')
  })

  if(item === 'height' && isNotNumber(value)){
    unit = null
  }

  return unit
}

function synchronousThreeEndRule(json, item, value) {
  // 黑名单(不走 同步3端规则)
  var blackList = ['line-clamp']
  if (blackList.includes(item)) {
    return
  }

  var deviceMode = mm.store.state.deviceMode

  var unit = getAvialUnit(json, item, value)
  if (unit) {
    if (
      (json.value[unit][deviceMode] === '%' || json.value[unit][deviceMode] === 'rem') &&
      !window.stopSynchronousThreeEnd
    ) {
      if(isThreeEndUnitSame(json, unit)){
        excuteSynchronousAction(json, item, value, deviceMode)
      }
    } else {
      if (unit.match('border-radius') || unit.match('shadow')) {
        if(isThreeEndUnitSame(json, unit)){
          excuteSynchronousAction(json, item, value, deviceMode)
        }
      }
    }
  } else {
    excuteSynchronousAction(json, item, value, deviceMode)
  }
}

function isThreeEndUnitSame(json, unit){
  var res = false
  if(
    json.value[unit]['diannao'] === json.value[unit]['pingban'] &&
    json.value[unit]['diannao'] === json.value[unit]['shouji']
  ){
    res = true
  }
  return res
}


//将数据变成可双向想绑定的数据
export function toComputedValues(arr, json, isNeedSynchronousThreeEndRule = true) {
  var res = []
  arr.forEach((item) => {
    const computedValue = computed({
      get() {
        if (isThreeEnds(json.value[item])) {
          return json.value[item][mm.store.state.deviceMode]
        } else {
          return json.value[item]
        }
      },
      set(value) {
        if(value.endsWith && value.endsWith('|specal')){
          var [val,languageId] = value.split('|');
          json.value[item] = setValueOfMuiltLanguagesJson(json.value[item], languageId, val)
        }else{
          if (isThreeEnds(json.value[item])) {
            json.value[item][mm.store.state.deviceMode] = value
          } else {
            json.value[item] = value
          }
        }


        excuteSynchronousThreeEndRule(json, item, value, isNeedSynchronousThreeEndRule)
      }

    })
    res.push(computedValue)
  })
  onBeforeUnmount(() => {
    res = undefined
  })

  return res
}

function isInMobileHead(node) {
  var res = false
  bubblingNode(node, (bubbledNode) => {
    if (bubbledNode.name === '移动端头部') {
      res = true
    }
  })
  return res
}

export function excuteSynchronousThreeEndRule(json, item, value, isNeedSynchronousThreeEndRule) {
  if (json && isThreeEnds(json.value[item])) {
    if (mm.store.state.deviceMode === 'diannao') {
      if (mm.router.currentRoute.value.query.editTemplate) {
        forcesynchronousThreeEnd(json, item, value)
      } else {
        if (isNeedSynchronousThreeEndRule) {
          synchronousThreeEndRule(json, item, value)
        }
      }
    } else {
      var currentNode = mm.store.state.dialogNodes[0]
      if (
        mm.store.state.deviceMode === 'pingban' &&
        isInMobileHead(currentNode) &&
        (currentNode.componentName === 'language_flagNameSelect' ||
          currentNode.componentName === 'mobile_nav')
      ) {
        if (isNeedSynchronousThreeEndRule) {
          synchronousThreeEndRule(json, item, value)
        }
      } else {
        json.value[item][mm.store.state.deviceMode + '_isChange'] = true
      }
    }
  }
}

//  弹框同步更新字段
export function syncUpateDialogField(node, customName, value, deviceMode) {
  modifyValueByDeviceMode(getNodeById(node.id), customName, value, deviceMode)
  if(mm.oldNode){
    modifyValueByDeviceMode(mm.oldNode, customName, value, deviceMode)
    var match = getMetaComponentItemByCustomName(mm.oldNode, customName)
    match.cacheKey = Date.now()
  }


}

export function syncHoverValue(newValue, node, metaComponent) {
  if (newValue) {
    var changedPairs = Object.keys(newValue).map((cssKey) => {
      return [
        cssKey,
        (() => {
          if (!newValue[cssKey]) {
            return 'transparent'
          }
          return newValue[cssKey][mm.store.state.deviceMode]
        })()
      ]
    })
    if (metaComponent.isSyncHover) {
      changedPairs.forEach((changedPair) => {
        var [changedKey, changedKeyValue] = changedPair
        modifyValueByCustomName(
          getNodeById(node.id),
          createCustomName(metaComponent.element, changedKey, metaComponent.componentType, true),
          changedKeyValue
        )
      })
    }
  }
}

export function reComputedHeight(node, actionPoint, isAllDeviceMode, metaComponent) {
  if (isAllDeviceMode) {
    ;['diannao', 'pingban', 'shouji'].forEach((deviceMode) => {
      reComputedHeightByDeviceMode(node, actionPoint, deviceMode, metaComponent)
    })
  } else {
    reComputedHeightByDeviceMode(node, actionPoint, mm.store.state.deviceMode, metaComponent)
  }
}

export function reComputedHeightByDeviceMode(node, actionPoint, deviceMode, metaComponent) {
  if (
    node.componentName === 'text_paragraph' ||
    node.componentName === 'text_title' ||
    node.componentName === 'text_scrollText'
  ) {
    if (
      node.data.design &&
      node.data.design['title_dynamicComputedHeightValue'] &&
      node.data.design['title_dynamicComputedHeightValue'][deviceMode] === 'byRowLength'
    ) {
      if (
        actionPoint === 'fontSize' ||
        actionPoint === 'lineHeight' ||
        actionPoint === 'textOverflow' ||
        actionPoint === 'padding'
      ) {
        var fontSize = node.data.design[(()=>{
          if(node.componentName === 'text_scrollText'){
            return 'scrollTextvalue_fontSize'
          }else{
            return 'title_fontSize'
          }
        })()][deviceMode]
        var fontSizeUnit = node.data.design[(()=>{
          if(node.componentName === 'text_scrollText'){
            return 'scrollTextvalue_fontSizeUnit'
          }else{
            return 'title_fontSizeUnit'
          }

        })()][deviceMode]
        var lineHeight = node.data.design['title_lineHeight'][deviceMode]
        var lineHeightUnit = node.data.design['title_lineHeightUnit'][deviceMode]
        var fontSizeOfPixel = getPixelValueFromOtherUnit(
          fontSizeUnit,
          fontSize,
          node,
          metaComponent
        )
        var lineHeightOfPixel = getPixelValueFromOtherUnit(
          lineHeightUnit,
          lineHeight,
          node,
          metaComponent
        )

        if (actionPoint === 'fontSize') {
          if (fontSizeOfPixel < lineHeightOfPixel) {
            modifyValueByDeviceMode(getNodeById(node.id), (()=>{
              if(node.componentName === 'text_scrollText'){
                return 'scrollTextvalue_fontSize'
              }else{
                return 'title_fontSize'
              }
            })(), fontSize, deviceMode)
            syncUpateDialogField(node, 'title_lineHeight', lineHeight, deviceMode)
            syncUpateDialogField(
              node,
              'self_height',
              supplimentPaddingAndBorder(
                lineHeightOfPixel * node.data.design['title_lineClamp'][deviceMode],
                node,
                deviceMode,
                metaComponent
              ),
              deviceMode
            )
          } else {
            modifyValueByDeviceMode(getNodeById(node.id), (()=>{
              if(node.componentName === 'text_scrollText'){
                return 'scrollTextvalue_fontSize'
              }else{
                return 'title_fontSize'
              }
            })(), fontSize, deviceMode)
            syncUpateDialogField(
              node,
              'title_lineHeight',
              getOtherUnitValueFromPixel(lineHeightUnit, fontSizeOfPixel, node, metaComponent),
              deviceMode
            )
            syncUpateDialogField(
              node,
              'self_height',
              supplimentPaddingAndBorder(
                fontSizeOfPixel * node.data.design['title_lineClamp'][deviceMode],
                node,
                deviceMode,
                metaComponent
              ),
              deviceMode
            )
          }
        } else if (actionPoint === 'lineHeight') {
          if (fontSizeOfPixel < lineHeightOfPixel) {
            modifyValueByDeviceMode(
              getNodeById(node.id),
              'title_lineHeight',
              lineHeight,
              deviceMode
            )
            syncUpateDialogField(node, (()=>{
              if(node.componentName === 'text_scrollText'){
                return 'scrollTextvalue_fontSize'
              }else{
                return 'title_fontSize'
              }
            })(), fontSize, deviceMode)
            syncUpateDialogField(
              node,
              'self_height',
              supplimentPaddingAndBorder(
                lineHeightOfPixel * node.data.design['title_lineClamp'][deviceMode],
                node,
                deviceMode,
                metaComponent
              ),
              deviceMode
            )
          } else {
            modifyValueByDeviceMode(
              getNodeById(node.id),
              'title_lineHeight',
              lineHeight,
              deviceMode
            )
            syncUpateDialogField(
              node,
              (()=>{
                if(node.componentName === 'text_scrollText'){
                  return 'scrollTextvalue_fontSize'
                }else{
                  return 'title_fontSize'
                }
              })(),
              getOtherUnitValueFromPixel(fontSizeUnit, lineHeightOfPixel, node, metaComponent),
              deviceMode
            )
            syncUpateDialogField(
              node,
              'self_height',
              supplimentPaddingAndBorder(
                lineHeightOfPixel * node.data.design['title_lineClamp'][deviceMode],
                node,
                deviceMode,
                metaComponent
              ),
              deviceMode
            )
          }
        } else if (actionPoint === 'textOverflow' || actionPoint === 'padding') {
          if (fontSizeOfPixel < lineHeightOfPixel) {
            modifyValueByDeviceMode(
              getNodeById(node.id),
              'self_height',
              supplimentPaddingAndBorder(
                lineHeightOfPixel * node.data.design['title_lineClamp'][deviceMode],
                node,
                deviceMode,
                metaComponent
              ),
              deviceMode
            )
          } else {
            modifyValueByDeviceMode(
              getNodeById(node.id),
              'self_height',
              supplimentPaddingAndBorder(
                fontSizeOfPixel * node.data.design['title_lineClamp'][deviceMode],
                node,
                deviceMode,
                metaComponent
              ),
              deviceMode
            )
          }
        }
      }
    }
    else if(
      node.data.design &&
      node.data.design['title_dynamicComputedHeightValue'] &&
      (
        node.data.design['title_dynamicComputedHeightValue'][deviceMode] === 'byContent' ||
        node.data.design['title_dynamicComputedHeightValue'][deviceMode] === 'none'

      )
    ){
      syncUpateDialogField(
        node,
        'self_height',
        'auto',
        deviceMode
      )
    }

  }
}

/**
 * 根据自定义名称获取元组件项
 * @param {Object} node - 节点对象
 * @param {string} customName - 要查找的自定义名称
 * @returns {Object|null} 返回匹配的元组件项，未找到则返回null
 */
export function getMetaComponentItemByCustomName(node, customName) {
  var res
  walkAllMetaComponentList(node, (walkedMetaComponent, parent) => {
    if (Object.values(walkedMetaComponent.name).includes(customName)) {
      res = walkedMetaComponent
    }
  })
  return res
}

//  根据组件类型获取所有元组件项值
function getMetaComponentItemByComponentType(node, key, componentType) {
  var match
  node.controllerModule[key].metaComponentList.forEach((group) => {
    group.children.forEach((item) => {
      if (item.componentType === componentType) {
        match = item
      }
    })
  })
  return match
}

self.getMetaComponentItemByComponentType = getMetaComponentItemByComponentType

//  根据标题获取元组件项值
function getMetaComponentItemByTitle(node, key, title) {
  var match
  node.controllerModule[key].metaComponentList.forEach((group) => {
    group.children.forEach((item) => {
      if (item.title === title) {
        match = item
      }
    })
  })
  return match
}

self.getMetaComponentItemByTitle = getMetaComponentItemByTitle

//  弹框同步更新字段
export function getMetaComponentItemByEnglishTitle(node, key, englishTitle) {
  var match
  node.controllerModule[key].metaComponentList.forEach((group) => {
    group.children.forEach((item) => {
      if (item.englishTitle === englishTitle) {
        match = item
      }
    })
  })
  return match
}

self.getMetaComponentItemByEnglishTitle = getMetaComponentItemByEnglishTitle

//  根据id获取元组件项值
export function getMetaComponentItemById(node, key, id) {
  var match
  node.controllerModule[key].metaComponentList.forEach((group) => {
    group.children.forEach((item) => {
      if (item.id === id) {
        match = item
      }
    })
  })
  return match
}

//  深拷贝
function deepCopy(arg) {
  if (typeof arg === 'object') {
    const result = Array.isArray(arg) ? [] : {}
    for (const key in arg) {
      if (arg[key] === null) {
        result[key] = null
      } else {
        result[key] = deepCopy(arg[key])
      }
    }
    return result
  } else {
    return arg
  }
}

//  获取样式dom
export function getStyleDomByNode(node) {
  var scriptId = 'scriptFor_' + node.id
  var styleDom = document.getElementById(scriptId)
  if (!styleDom) {
    styleDom = document.createElement('style')
    styleDom.className = 'generatedStyle'
    styleDom.id = scriptId
    styleDom.type = 'text/css'
    document.body.appendChild(styleDom)
  }
  return styleDom
}

//  遍历节点
export const walkNode = (node, callback, level) => {
  if (typeof level === 'undefined') {
    level = 0
  }
  callback && callback(node, level)
  if (node.list) {
    level++
    node.list.forEach((subNode, subNodeIndex) => {
      subNode._index =
        (() => {
          if (typeof node._index === 'undefined') {
            node._index = '0'
          }
          return node._index
        })() +
        '_' +
        subNodeIndex
      walkNode(subNode, callback, level)
    })
  }
}
globalThis.walkNode = walkNode
//  添加默认值（暂无使用）
export const subjoinDefaultValue = (value, defalutValue) => {
  if (typeof value === 'undefined' || value === '') {
    return defalutValue
  } else {
    return value
  }
}

/**
 * @remark 排序方法
 * @param {Array} arr 原数组
 * @param {string} field 排序字段
 * @param {number} sort 1:升，-1:降
 */
export const sortFun = (arr, field, sort = 1) => {
  const sortBy = (attr, rev) => {
    if (rev == undefined) {
      rev = 1
    } else {
      rev ? 1 : -1
    }
    return function (a, b) {
      a = a[attr]
      b = b[attr]
      if (a < b) {
        return rev * -1
      }
      if (a > b) {
        return rev * 1
      }
      return 0
    }
  }

  return arr.sort(sortBy(field, sort))
}

/**
 * @remark 判断字符串是否以 "&#" 开头
 * @param {string} str - 需要判断的字符串
 * @returns {boolean} - 如果以 "&#" 开头返回 true，否则返回 false
 */
export const startsWithEntity = (str) => {
  return str.startsWith('&#')
}

export const updateRootStyle = (themeConfig) => {
  if (!themeConfig) return
  const colorStyleTagId = 'global-theme-color-style'
  const styleTagId = 'global-theme-style'
  const styleDom = document.getElementById(styleTagId)
  const colorStyleDom = document.getElementById(colorStyleTagId)
  if (styleDom) document.head.removeChild(styleDom)
  if (colorStyleDom) document.head.removeChild(colorStyleDom)
  const styleTag = document.createElement('style')
  styleTag.id = styleTagId
  let styles = ''
  styles += `--anchorTextColor: ${themeConfig.anchorTextColor};`
  for (let v of Object.keys(themeConfig.color)) {
    styles += `
      --${v}: ${themeConfig.color[v]};
    `
  }
  styles += `--globalFont: ${themeConfig.fontFamily};`
  for (let value of themeConfig.text) {
    styles += `
      --${value.name}-family: ${value.fontFamily};
      --${value.name}-pc-size: ${value['diannao'].fontSize};
      --${value.name}-pad-size: ${value['pingban'].fontSize};
      --${value.name}-phone-size: ${value['shouji'].fontSize};
      --${value.name}-pc-letter-spacing: ${value['diannao'].letterSpacing};
      --${value.name}-pad-letter-spacing: ${value['pingban'].letterSpacing};
      --${value.name}-phone-letter-spacing: ${value['shouji'].letterSpacing};
    `
  }
  styles += transformToCssVarity(themeConfig.popagation)
  styleTag.innerHTML = `
    :root {
      ${styles}
    }
  `
  document.head.appendChild(styleTag)
}

export const updateTextStyle = (node, arr = []) => {
  const { deviceMode } = mm.store.state
  initData(node, arr)
  const originalOnDialogChange = node.onDialogChange
  node.onDialogChange = (item, item2, item3) => {
    if (typeof originalOnDialogChange === 'function') {
      originalOnDialogChange(item, item2, item3)
    }
    if (item2 === 'design' && item.componentType === 'textTheme') {
      const textThemeTypeId = item.value['text-theme-id'][deviceMode]
      const textThemeType = item.value['text-theme-type'][deviceMode]
      const textArr = [
        `${item.element}_fontSize`,
        `${item.element}_fontFamily`,
        `${item.element}_letterSpace`
      ]
      if (textThemeType === 'default') {
        setComponentVisibility(item3.controllerModule, textArr, true)
        const {
          authInfo: {
            ksh_global_theme_color: { text }
          }
        } = mm.store.state
        const style = text.find((v) => v.id === textThemeTypeId)
        style && applyThemeStyle(item3.data.design, item.element, style)
      } else {
        setComponentVisibility(item3.controllerModule, textArr, false)
        applyDefaultStyle(item3.data.design, item.element)
      }
    }
  }
}
const initData = (node, arr) => {
  const { deviceMode } = mm.store.state
  if (!verAction(node)) return
  node.controllerModule.design.metaComponentList.forEach((v) => {
    const textTheme = v.children.find((v) => v.componentType === 'textTheme')
    if (!!textTheme) {
      const { element } = textTheme
      setComponentVisibility(
        node.controllerModule,
        [`${element}_fontSize`, `${element}_fontFamily`, `${element}_letterSpace`],
        textTheme.value['text-theme-type'][deviceMode] === 'default'
      )

      const textThemeTypeId = textTheme.value['text-theme-id'][deviceMode]
      const textThemeType = textTheme.value['text-theme-type'][deviceMode]
      if (textThemeType === 'default') {
        const {
          authInfo: {
            ksh_global_theme_color: { text }
          }
        } = mm.store.state

        const style = text.find((v) => v.id === textThemeTypeId)
        if (style) {
          applyThemeStyle(node.data.design, element, style)
        }
        if (textThemeTypeId === 1) {
          applyDefaultStyle(node.data.design, element)
        }
      } else {
        applyDefaultStyle(node.data.design, element)
      }
    }
  })
}

const verAction = (node) => {
  const { actions } = node
  let isVer = false
  if (!actions) {
    isVer = true
  } else {
    if (actions.includes('design')) {
      isVer = true
    } else {
      for (let v of actions) {
        if (isObject(v) && v.name === 'design') {
          for (let [key, value] of Object.entries(v.config)) {
            for (let vv of value) {
              if (String(vv).includes('textTheme')) isVer = true
            }
          }
        }
      }
    }
  }
  return isVer
}
const isObject = (value) => {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}
export const setComponentVisibility = (controllerModule, arr, isHide) => {
  controllerModule.design.metaComponentList.forEach((v) => {
    for (let value of v.children) {
      if (arr.includes(value.element + '_' + value.componentType)) {
        value.isHide = isHide
      }
    }
  })
}

export const applyThemeStyle = (designData, element, style) => {
  for (let key of Object.keys(designData)) {
    if (key === element + '_fontSize') {
      designData[key]['diannao'] = `var(--${style.name}-pc-size)`
      designData[key]['pingban'] = `var(--${style.name}-pad-size)`
      designData[key]['shouji'] = `var(--${style.name}-phone-size)`
    } else if (key === element + '_fontSizeUnit') {
      designData[key]['diannao'] = 'px'
      designData[key]['pingban'] = 'px'
      designData[key]['shouji'] = 'px'
    } else if (key === element + '_fontFamily') {
      designData[key]['diannao'] = `var(--${style.name}-family)`
      designData[key]['pingban'] = `var(--${style.name}-family)`
      designData[key]['shouji'] = `var(--${style.name}-family)`
    } else if (key === element + '_letterSpacing') {
      designData[key]['diannao'] = `var(--${style.name}-pc-letter-spacing)`
      designData[key]['pingban'] = `var(--${style.name}-pad-letter-spacing)`
      designData[key]['shouji'] = `var(--${style.name}-phone-letter-spacing)`
    } else if (key === element + '_letterSpacingUnit') {
      designData[key]['diannao'] = 'px'
      designData[key]['pingban'] = 'px'
      designData[key]['shouji'] = 'px'
    }
  }
}

export const applyDefaultStyle = (designData, element) => {
  for (let key of Object.keys(designData)) {
    if (key === element + '_fontSize') {
      if (isMayChange(designData[key]['diannao'])) designData[key]['diannao'] = 16
      if (isMayChange(designData[key]['pingban'])) designData[key]['pingban'] = 16
      if (isMayChange(designData[key]['shouji'])) designData[key]['shouji'] = 14
    } else if (key === element + '_fontFamily') {
      if (isMayChange(designData[key]['diannao'])) designData[key]['diannao'] = 'var(--globalFont)'
      if (isMayChange(designData[key]['pingban'])) designData[key]['pingban'] = 'var(--globalFont)'
      if (isMayChange(designData[key]['shouji'])) designData[key]['shouji'] = 'var(--globalFont)'
    } else if (key === element + '_letterSpacing') {
      if (isMayChange(designData[key]['diannao'])) designData[key]['diannao'] = 0
      if (isMayChange(designData[key]['pingban'])) designData[key]['pingban'] = 0
      if (isMayChange(designData[key]['shouji'])) designData[key]['shouji'] = 0
    }
  }
}

const isMayChange = (value, num) => {
  return value === ''
}

const isString = (value) => {
  return typeof value === 'string'
}

const isHaveOneChange = (value) => {
  return (
    isMayChange(value['diannao']) || isMayChange(value['pingban']) || isMayChange(value['shouji'])
  )
}
const colorPickDialogs = new Set()
export function rColorPickDialog(refObj) {
  colorPickDialogs.add(refObj)
}
export function uColorPickDialog(refObj) {
  colorPickDialogs.delete(refObj)
}
export function cColorPickDialogs(except) {
  colorPickDialogs.forEach((refObj) => {
    if (refObj !== except) refObj.value = false
  })
}
